export default {
  property: {},
  properties: [],
  propertyAdd: {
    isFormVisible: false,
    isValidCommunity: false
  }
}
